import React from 'react';
import { Helmet } from 'react-helmet-async';

const Clarity = () => {
    return (
        <Helmet>
            <script defer>
                {`
                (function (window, document, clarity, script, projectId) {
                    window[clarity] = window[clarity] || function () {
                        (window[clarity].q = window[clarity].q || []).push(arguments);
                    };

                    const scriptElement = document.createElement(script);
                    scriptElement.async = true;
                    scriptElement.src = "https://www.clarity.ms/tag/" + projectId;

                    const firstScript = document.getElementsByTagName(script)[0];
                    firstScript.parentNode.insertBefore(scriptElement, firstScript);
                })(window, document, "clarity", "script", "kukun8h9kh");
                `}
            </script>
        </Helmet>
    );
};

export default Clarity;